import { Component, signal } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SitePolygoneDto } from 'src/app/bo/site/sitePolygone';
import { DxfServiceService } from 'src/app/services/dxf-service.service';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';

/**
 * Modal used to upload a DXF from the map "DXF" panel,
 * mirroring the orthophoto add modal.
 */
@Component({
  selector: 'app-site-dxf-add-file-modal',
  templateUrl: './site-dxf-add-file-modal.component.html',
  styleUrls: ['./site-dxf-add-file-modal.component.scss'],
  standalone: false
})
export class SiteDxfAddFileModalComponent {
  /** Provided through initialState by the caller */
  siteId: number;

  protected readonly fileName = signal('');
  protected readonly saving = signal(false);
  protected color = '#000000';

  private rawDxfContent = '';

  constructor(
    public bsModalRef: BsModalRef,
    private readonly dxfService: DxfServiceService,
    private readonly fonctionsService: FonctionsService
  ) { }

  protected get canSave(): boolean {
    return !!this.fileName() && !!this.rawDxfContent && !this.saving();
  }

  protected triggerFilePicker(): void {
    document.getElementById('dxfFileInput')?.click();
  }

  protected onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) {
      return;
    }

    const file = input.files[0];
    this.fileName.set(file.name);

    const reader = new FileReader();
    reader.onload = e => {
      this.rawDxfContent = (e.target?.result as string) ?? '';
    };
    reader.readAsText(file);
  }

  protected save(): void {
    if (!this.canSave) {
      return;
    }

    this.saving.set(true);

    const compressedDxf = this.dxfService.compressDxf(this.rawDxfContent);
    const polygone = new SitePolygoneDto(0, this.color, this.fileName(), true, compressedDxf, undefined);

    this.dxfService.saveToSitePolygone(this.siteId, polygone)
      .then(() => {
        this.fonctionsService.launch_toast(true);
        this.bsModalRef.hide();
      })
      .catch(() => {
        this.saving.set(false);
        this.fonctionsService.launch_toast(false);
      });
  }

  protected cancel(): void {
    this.bsModalRef.hide();
  }
}
